export default {
  kosten: "2f413911-a2dc-c179-e050-007f0101705e",
  finanzierung: "5f681393-a2d3-4423-ba35-54d09156651b",
};
